import { ApiState, IApiState } from '../../shared/models/api-state.model';
import { ActionReducer, createFeature, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import { CLAIMS_API_ACTIONS } from '../actions';
import { EClaimName, EClaimOperation } from '../../core/configurations/claims';

export const CLAIMS_STATE_KEY = 'claims';

export interface IClaimsState {
  claims: IApiState<string[]>;
}

export const initialState: IClaimsState = {
  claims: new ApiState<string[]>(),
};

const reducer: ActionReducer<IClaimsState> = createReducer<IClaimsState>(
  initialState,
  on(
    CLAIMS_API_ACTIONS.get,
    (state): IClaimsState => ({
      ...state,
      claims: state.claims.load(),
    }),
  ),
  on(
    CLAIMS_API_ACTIONS.error,
    (state, { error }): IClaimsState => ({
      ...state,
      claims: state.claims.setError(error),
    }),
  ),
  on(
    CLAIMS_API_ACTIONS.success,
    (state, { data }): IClaimsState => ({
      ...state,
      claims: state.claims.success(data),
    }),
  ),
);

export const CLAIMS_REDUCER = createFeature({
  name: CLAIMS_STATE_KEY,
  reducer,
  extraSelectors: ({ selectClaims }) => ({
    can: (claimName: EClaimName, operation: EClaimOperation): MemoizedSelector<any, boolean> =>
      createSelector(selectClaims, (claimsState: IApiState<string[]>): boolean =>
        Boolean(
          claimsState?.data?.filter(
            (claim) =>
              claim.toLowerCase().includes(claimName.toLowerCase()) &&
              claim.toLowerCase().includes(operation.toLowerCase()),
          )?.length,
        ),
      ),
    has: (claimName: EClaimName): MemoizedSelector<any, boolean> =>
      createSelector(selectClaims, (claimsState: IApiState<string[]>): boolean =>
        Boolean(claimsState.data?.some((claim) => claim.toLowerCase().includes(claimName.toLowerCase()))),
      ),
  }),
});
